<template>
  <div class="Grid-layout Grid-card-inspiration" v-if="cards?.length">
    <ul :class="`Grid-card-inspiration__list ${colsClass}`">
      <li :key="`card-${card.contentfulId}`" class="Grid-card-inspiration__list-item" v-for="card in cards">
        <ux-molecules-card-inspiration v-bind="formatedCard(card)" :variant="cardsVariant" />
      </li>
    </ul>
  </div>
</template>
<script setup lang="ts">
import { CardInspirationVariant } from '~/components/ux/molecules/CardInspiration/types';
import { EditorialContent } from '~/graphql';
import { imgxSizes } from '~/helpers/imageSizes';

import { CardInspirationProps } from '../CardInspiration/CardInspiration.vue';

export interface GridCardInspirationProps {
  cards: EditorialContent[] | null;
  cardsVariant?: CardInspirationVariant;
  columns: 2 | 3 | 4 | null;
}

const localePath = useLocalePath();

const { t } = useI18n();

const props = withDefaults(defineProps<GridCardInspirationProps>(), {
  cards: null,
  cardsVariant: 'medium',
  columns: 3
});

const colsClass = computed(() => {
  return props.columns ? `Grid-card-inspiration__list--${props.columns}cols` : '';
});

const formatedCard = (card: EditorialContent): CardInspirationProps => {
  return {
    alt: card?.coverImage?.alt ?? '',
    href: localePath(`/${card?.variant?.toLocaleLowerCase()}/${card?.slug}`),
    label: t(`ux.molecules.inspirationFilterContent.${card?.variant?.toLocaleLowerCase()}`) ?? '',
    src: card?.coverImage?.srcSet?.substring(0, card?.coverImage?.srcSet.indexOf(`${imgxSizes.sm}w`)).trim() ?? '',
    teaser: card?.subtitle ?? '',
    title: card?.title ?? ''
  };
};
</script>
<style lang="scss" scoped>
@use 'GridCardInspiration.scss';
</style>
